import { GQLMerchDecorationFragment, GQLProductSideFragment, GQLProductTileFragment } from '@theprintbar/graphql';
import {
	ArtworkAndMeta,
	ImageSize,
	getArtboardPositionAsPercentage,
	getDecorationImageUrl,
	getDecorationPositionAsPercentageOfProduct,
	getProductImageUrl,
	positionToPercentageString,
	sizedImage,
	withDomain,
} from '@theprintbar/shared';
import { useEffect, useState } from 'react';

interface DecorationPreviewProps {
	product: GQLProductTileFragment;
	webDomain?: string;
	side: GQLProductSideFragment;
	colourCode: string;
	decoration?: ArtworkAndMeta;
	merchDecoration?: GQLMerchDecorationFragment;
	className?: string;
}

export function DecorationPreview({
	product,
	side,
	webDomain,
	colourCode,
	decoration,
	merchDecoration,
	className,
}: DecorationPreviewProps) {
	const [decorationUrl, setDecorationUrl] = useState<string>();

	useEffect(() => {
		if (decoration) {
			setDecorationUrl(getDecorationImageUrl(decoration));
		}
	}, [decoration, merchDecoration, side, product, colourCode]);

	return (
		<div className="aspect-square relative h-full mx-auto">
			<img
				loading="lazy"
				className="w-full h-full"
				src={getProductImageUrl({
					product,
					productCode: product.code,
					colourCode,
					side: side.side,
					size: ImageSize.Medium,
				})}
			/>
			{decoration && decorationUrl && (
				<img
					loading="lazy"
					src={decorationUrl}
					className="absolute"
					style={positionToPercentageString(getDecorationPositionAsPercentageOfProduct(side, decoration.meta))}
				/>
			)}
			{merchDecoration && (
				<img
					loading="lazy"
					src={merchDecoration.design?.image.url}
					className="absolute"
					style={positionToPercentageString(getDecorationPositionAsPercentageOfProduct(side, merchDecoration))}
				/>
			)}
		</div>
	);
}
